var $ = jQuery;

jQuery(document).ready(function($){
	var sliderControls = $('.section-tab-slider__tabs li');

	sliderControls.on('click', function() {
		var slide = $(this).data('target-slide');
		var current = $(this).closest('.section-tab-slider__content').find('.orbit-slide.is-active').data('slide');
		var ltr = slide > current;

		if ( slide === current ) {
			return;
		}

		var allTabs = $(this).parent();

		var section = $(this).closest('.section-tab-slider');
		var sliderContent = section.find('.section-tab-slider__content');
		var chosenSlide = sliderContent.find('[data-slide='+slide+']');

		sliderContent.foundation('changeSlide', ltr, chosenSlide, slide);

		updateIndicator($(this));
	})

	var sliderSections = $('.section-tab-slider');

	sliderSections.each(function() {
		var active = $(this).find('.section-tab-slider__tab-content.active');

		updateIndicator(active);

		$(window).resize(function() {
			updateIndicator(active);
		})
	});
});

$(document).bind('beforeslidechange.zf.orbit', function(e, currentSlide, nextSlide) {
	var slider = document.getElementById(e.target.id);
	var currentSlideNumber = currentSlide[0].getAttribute('data-slide');
	var nextSlideNumber = nextSlide[0].getAttribute('data-slide');

	var activeTab = slider.querySelector('[data-target-slide="'+currentSlideNumber+'"]');
	activeTab.classList.remove('active');

	var nextTab = slider.querySelector('[data-target-slide="'+nextSlideNumber+'"]');
	nextTab.classList.add('active');

	updateIndicator($(nextTab));
});

var updateIndicator = function ($activeTab) {
	$activeTab.parent().find('.section-tab-slider__indicator').css({'height': $activeTab.innerHeight() + 'px', 'top': $activeTab.position().top + 'px' });
};